import React, { useState } from 'react';
import '../App.css';
function Button({onClick,text,color}) {
  

  return (
    <div>
      <button className='button'style={{border:'2px solid #000000',backgroundColor : color}} onClick={onClick}>{text}</button>
    </div>
  );
}

export default Button;